import Vue from "vue";
export const EventBus = new Vue();

/**
 * Emitted by flows that apply a long chain of store mutations in sequence (e.g.
 * the stock options reset in Stock.vue). Pricing suspends its watcher-driven
 * price/SKU requests between suspend and resume so the request body — which is
 * serialized from live store state at call time — is never built from a
 * half-applied configuration.
 */
export const PRICING_SUSPEND = "pricing:suspend";
export const PRICING_RESUME = "pricing:resume";
